import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Asymptotes feature parameters */
export interface AsymptotesParams {
  /** Reference to parent function element */
  of: string;
  /** Horizontal asymptote value (y = k), if known */
  horizontal?: number;
  /** Vertical asymptote values (x = h), if known */
  vertical?: number[];
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const ASYMPTOTES_DEFAULT_PARAMS: Omit<AsymptotesParams, 'of'> = {};

/**
 * Default theme for asymptotes feature.
 * Dashed lines for asymptotes.
 *
 * Subparts:
 * - `horizontal`: Horizontal asymptote line
 * - `vertical`: Vertical asymptote lines
 */
export const ASYMPTOTES_DEFAULTS: FeatureStyleNode = {
  line: { color: 'neutral', strokeWidth: 2, dash: 3 },
  subparts: {
    horizontal: { line: { color: 'neutral', strokeWidth: 2, dash: 3 } },
    vertical: { line: { color: 'neutral', strokeWidth: 2, dash: 3 } },
  },
};
